import styled, { css } from 'styled-components'

export const LoadingWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.url &&
    css`
      background-image: ${`url(${props.url})`};
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    `}
`

export const dimmerStyle = {
  display: 'flex',
  height: '100vh',
  justifyContent: 'flex-start',
  alignItems: 'center',
  opacity: 0.65,
}
